// https://www.youtube.com/watch?v=WbV3zRgpw_E&t=6960s
import React, { useState }  from 'react'
import Title from '../_title/Title'
// import Projects1 from './Projects1'
import AboutUs1 from './AboutUs1'
import AboutUs2 from './AboutUs2'
// import Projects3 from './Projects3'
// import Projects4 from './Projects4'




const AboutUsScreen = () => {
  return (
    <div>
      <div className="container">
        <Title title="."/>
        {/* <Title title=""/> */}
        <AboutUs1/>  
        <AboutUs2/> 
      </div>
    </div>

  )
}

export default AboutUsScreen